<template>
  <div>
    <h3 class="text-center">
      {{ $t('General request quota table') }} {{ $t('According to organizations.') }}</h3>
    <b-card
      no-body
    >
      <div
        v-if="canExportAcceptedTable(letter)"
        class="m-1"
      >
        <!-- Table Top -->
        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-button
                variant="success"
                @click="exportExcel"
              >
                <b-icon icon="file-earmark-excel" /> Excel
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refAcceptedOrgTable"
        :items="table_one"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        :empty-text="$t('No matching records found')"
        :busy="isBusy"
        class="accepted-org-table position-relative table-striped table-bordered"
      >
        <template #thead-top="">
          <b-tr>
            <b-th
              colspan="2"
              style="background: none"
            />
            <b-th
              v-if="!isTargeted()"
              colspan="2"
              class="text-center"
              style="background: none"
            >
              {{ $t('Scientific potential of the institute') }}
            </b-th>
            <b-th
              v-if="!isTargeted()"
              colspan="3"
              class="text-center"
              style="background: none"
            >
              {{ $t('Number of students at the institute') }}
            </b-th>
            <b-th
              :colspan="dcTypes.length + 1"
              class="text-center"
              style="background: none"
            >
              {{ $t('The need for specialization for {year}', { year: letter.period.admission_year}) }}
            </b-th>
          </b-tr>
        </template>
        <template
          v-for="dcType in dcTypes"
          v-slot:[`head(${dcType.id})`]=""
        >
          {{ $langName(getDcType(dcType.id).name) }}
        </template>

        <template #head()="data">
          {{ getHead(data) }}
        </template>

        <template #head(name)="">
          {{ $t('Organization') }}
        </template>

        <!-- Column: Index -->
        <template #cell(index)="data">
          <span style="display: block; width: 30px">
            <feather-icon
              :icon="data.detailsShowing ? 'ChevronDownIcon': 'ChevronRightIcon'"
              @click="data.toggleDetails"
            />
            {{ data.index + 1 }}
          </span>
        </template>
        <template
          #row-details="data"
          style="padding: 0"
        >
          <accepted-inner
            :letter-id="data.item.id"
            :prefix="data.index + 1 + '.'"
            :table-columns="tableColumns"
          />
        </template>

        <template #cell(name)="data">
          {{ $langName(JSON.parse(data.item.name)) }}
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner
              variant="primary"
              label="Text Centered"
            />
          </div>
        </template>
      </b-table>
    </b-card>
    <h3 class="text-center">
      {{ $t('General request quota table') }} {{ $t('According to directions.') }}</h3>
    <b-card
      no-body
    >
      <b-table
        ref="refAcceptedDirectionTable"
        :items="table_two"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        :empty-text="$t('No matching records found')"
        :busy="isBusy"
        class="position-relative table-bordered"
      >
        <template #thead-top="">
          <b-tr>
            <b-th
              colspan="2"
              style="background: none"
            />
            <b-th
              v-if="!isTargeted()"
              colspan="2"
              class="text-center"
              style="background: none"
            >
              {{ $t('Scientific potential of the institute') }}
            </b-th>
            <b-th
              v-if="!isTargeted()"
              colspan="3"
              class="text-center"
              style="background: none"
            >
              {{ $t('Number of students at the institute') }}
            </b-th>
            <b-th
              :colspan="dcTypes.length + 1"
              class="text-center"
              style="background: none"
            >
              {{ $t('The need for specialization for {year}', { year: letter.period.admission_year}) }}
            </b-th>
          </b-tr>
        </template>

        <template #head()="data">
          {{ getHead(data) }}
        </template>

        <template #head(name)="">
          {{ $t('Direction') }}
        </template>

        <!-- Column: Index -->
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>

        <template #cell(name)="data">
          {{ data.item.code + '-' + $langName(JSON.parse(data.item.name)) }}
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner
              variant="primary"
              label="Text Centered"
            />
          </div>
        </template>
      </b-table>
    </b-card>
  </div>

</template>

<script>
import {
  BCard, BTable, BSpinner, BTh, BTr, BRow, BCol, BButton,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import AcceptedInner from './AcceptedInner.vue'
import permission from '../permission'
import store from '@/store'
import statisticModule from '@/store/statistic'

export default {
  components: {
    BCard,
    BTable,
    BSpinner,
    BTr,
    BTh,
    BRow,
    BCol,
    BButton,
    AcceptedInner,
  },
  props: {
    moduleName: {
      type: String,
      default: 'letter',
    },
  },
  computed: {
    table_one() {
      return this.$store.state[this.moduleName].table_one
    },
    table_two() {
      return this.$store.state[this.moduleName].table_two
    },
    letter() {
      return this.$store.state[this.moduleName].letter
    },
    dcTypes() {
      return this.$store.getters[this.isTargeted() ? 'staticModule/getTargetedDcTypes' : 'staticModule/getSimpleDcTypes']
    },
  },
  mounted() {
    this.$store.dispatch(`${this.moduleName}/accepted`, this.$route.params.id).finally(() => {
      this.isBusy = false
    })
  },
  created() {
    this.$store.dispatch('staticModule/dcType')
    if (this.isTargeted()) {
      this.tableColumns = [
        { key: 'index', label: '#' },
        { key: 'name', label: 'Name', sortable: true },
      ]
    }
    const { dcTypes } = this
    dcTypes.forEach(dcType => {
      this.tableColumns.push({
        key: `${dcType.id}`,
        tdClass: 'max-min-150',
      })
    })
    this.tableColumns.push({
      key: 'total',
      tdClass: 'max-min-150',
    })
  },
  methods: {
    getDcType(id) {
      return this.$store.getters['staticModule/getDcType'](Number(id))
    },
    getHead(head) {
      const col = head.column
      if (Number(col) >= 100 && Number(col) <= 700) {
        return this.$langName(this.getDcType(col).name)
      }
      return this.$t(head.label)
    },
    isTargeted() {
      return (this.letter.letter_type === this.$store.state.staticModule.letterTypeTargeted)
    },
    exportExcel() {
      this.$store.dispatch(`${this.MODULE_STATISTIC}/ministryReport`, this.letter.id).then(res => {
        const link = document.createElement('a')
        link.href = res.data.path
        link.setAttribute('download', true)
        document.body.appendChild(link)
        link.click()
      }).catch(err => {
        this.$errorSwal(this, err)
      })
    },
  },
  setup() {
    const tableColumns = [
      { key: 'index', label: '#', tdClass: 'max-min-75' },
      {
        key: 'name', label: 'Name', sortable: true, tdClass: 'max-min-250',
      },
      {
        key: 'dc_amount', label: 'Dc amount', sortable: true, tdClass: 'max-min-150',
      },
      {
        key: 'phd_amount', label: 'Phd amount', sortable: true, tdClass: 'max-min-150',
      },
      {
        key: 'dc_student', label: 'Dc student', sortable: true, tdClass: 'max-min-150',
      },
      {
        key: 'phd_student', label: 'Phd student', sortable: true, tdClass: 'max-min-150',
      },
      {
        key: 'independent_student', label: 'Independent student', sortable: true, tdClass: 'max-min-150',
      },
    ]
    const isBusy = true
    const MODULE_STATISTIC = 'statistic'
    // Register module
    if (!store.hasModule(MODULE_STATISTIC)) store.registerModule(MODULE_STATISTIC, statisticModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_STATISTIC)) store.unregisterModule(MODULE_STATISTIC)
    })
    return {
      tableColumns,
      isBusy,
      ...permission(),
      MODULE_STATISTIC,
    }
  },
}
</script>

<style>
  .accepted-org-table .b-table .b-table-details > td {
    padding-right: 0 !important;
  }
  .b-table-has-details + tr > td {
    padding: 0;
  }
  .max-min-50 {
    max-width: 50px;
    min-width: 50px;
  }
  .max-min-175 {
    max-width: 175px;
    min-width: 175px;
  }
  .max-min-75 {
    max-width: 75px;
    min-width: 75px;
  }
  .max-min-150 {
    max-width: 175px;
    min-width: 175px;
  }

  .max-min-250 {
    max-width: 250px;
    min-width: 250px;
  }
</style>
